"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAppSelector } from "appHooks";
import { authSelector } from "features/auth/auth.selectors";
import { configSelector } from "features/config/config.selectors";
import Intro from "./intro/page";

const Home = () => {
  const router = useRouter();
  const { data: authData } = useAppSelector(authSelector);
  const { locale } = useAppSelector(configSelector);

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const token = authData.token;
    if (!token) {
      router.push(`/${locale}/login`);
    }
  }, [locale, authData.token, router]);

  if (!isMounted) return null;

  if (authData.token) {
    return <Intro />;
  }

  return null;
};

export default Home;
